export default __webpack_public_path__ + "static/media/Strugani 11.bc8b0913.jpg";